import React from 'react';
import clsx from 'clsx';


import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Copyright from './components/Bottom'
import useStyles from './styles'
import {Content} from './components/content/index'


export default function Dashboard() {
  const classes = useStyles();
  const [open] = React.useState(true);
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar} style={{backgroundColor:"#013F8D"}}>
          <Grid container spacing={1}>
            <Grid item xs={2} md={2} lg={2}>
              <img style={{height:"3.5rem"}} src="bcp.png"></img>
            </Grid>
            <Grid item xs={10} md={10} lg={10} className={classes.gridDash}>
              <Typography  variant="h4" color="inherit" noWrap className={classes.title}>
                Dashboard Performance BCP
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="xl" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
              <Content interval={10000}/>
              </Paper>
            </Grid>
          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/layouts/index.js